/*
 * @Author: your name
 * @Date: 2022-02-06 15:40:03
 * @LastEditTime: 2023-03-29 16:24:33
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsyTextEditor\index.jsx
 */

import React, { Component } from 'react'
import { BsyUtils } from '../../utils/Utils';
import BsyDateTime from '../BsyDateTime';
import { BsyWidget } from '../BsyWidget';
import './index.css'
import { dayjsUtils } from '../../utils/dayjsUtils';

export default class BsyDateTimeLimit extends BsyWidget {

  constructor(props) {
    super({
      baseCls: "bsy-datetime-limit",
      width4number: 150,
      ...props
    })
    this.state = {
      value: this.options.value,
      maxMinValue: null, //后一个时间的最小值限制
      minMaxValue: null, //前一个时间的最大值限制
    }

  }

  handleChange(event) {
    this.value = event.target.value;
    this.setState({ value: event.target.value });
  }



  getValue = () => {
    let a = this.getRValue(this.max.getValue(), 'max')
      , b = this.getRValue(this.min.getValue(), 'min')
      , c = {};
    BsyUtils.isObjectEmpty(b) || (c.min = b === '' ? null : b);
    BsyUtils.isObjectEmpty(a) || (c.max = a === '' ? null : a);
    return c
  }

  getRealValue = () => {
    let a = this.getRValue(this.max.getRealValue(), 'max', "text")
      , b = this.getRValue(this.min.getRealValue(), 'min', "text")
      , c = {};
    BsyUtils.isObjectEmpty(b) || (c.min = b === '' ? null : b);
    BsyUtils.isObjectEmpty(a) || (c.max = a === '' ? null : a);
    return c
  }

  getContextMin = (context) => {
    this.min = context
  }


  getContextMax = (context) => {
    this.max = context
  }


  getRValue = (a, type, mode = "") => {
    const { format } = this.options;
    switch (format) {

      case "yyyy-MM-dd HH:mm:ss": {
        if (!BsyUtils.isObjectEmpty(a)) {
          let d = new Date(a);
          if (mode === "text") {
            return BsyUtils.date2Str(d, format)
          }
          return d.getTime()
        }
        break;
      }
      case "yyyy-MM":
        {
          if (!BsyUtils.isObjectEmpty(a)) {
            let d = new Date(a);
            d.setDate(1);
            if (mode === "text") {
              return BsyUtils.date2Str(d, format)
            }
            if (type === 'min') {
              let d = new Date(a);
              d.setDate(1);
              d.setHours(0, 0, 0, 0)
              if (mode === "text") {
                return BsyUtils.date2Str(d, format)
              }
              return d.getTime();
            }
            else {
              let e = new Date(a);
              let m = e.getMonth();
              d.setMonth(m + 1, 1);
              d.setHours(0, 0, 0, 0)
              d.setMilliseconds(-1);
              if (mode === "text") {
                return BsyUtils.date2Str(d, format)
              }
              return d.getTime();
            }
          }
          break;
        }
      case "yyyy":
        {
          if (!BsyUtils.isObjectEmpty(a)) {
            if (type === 'min') {
              let d = new Date(a);
              d.setMonth(0, 1);
              d.setHours(0, 0, 0, 0)
              if (mode === "text") {
                return BsyUtils.date2Str(d, format)
              }
              return d.getTime()
            } else {
              let d = new Date(a);
              let y = d.getFullYear();
              d.setFullYear(y + 1, 0, 1);
              d.setHours(0, 0, 0, 0);
              d.setMilliseconds(-1);
              if (mode === "text") {
                return BsyUtils.date2Str(d, format)
              }
              return d.getTime();
            }

          }
          break;
        }
      case "yyyy-MM-dd":
      default: {
        if (!BsyUtils.isObjectEmpty(a)) {
          if (type === 'min') {
            let d = new Date(a);
            d.setHours(0, 0, 0, 0)
            if (mode === "text") {
              return BsyUtils.date2Str(d, format)
            }
            return d.getTime()
          } else {
            let d = new Date(a);
            d.setHours(23, 59, 59, 999)
            if (mode === "text") {
              return BsyUtils.date2Str(d, format)
            }
            return d.getTime()
          }
        }
        break;
      }
    }
    return null;
  }

  render() {
    let that = this;
    const { cssName, width4number, format, style } = this.options;
    const { value, maxMinValue, minMaxValue } = this.state
    let css = {
      width: this.options.width,
      height: this.options.height,
    }
    return (
      <div
        ref={this.element}
        className={cssName} style={css}>
        <div className='limit-item'>
          <BsyDateTime
            getContext={this.getContextMin}
            width={width4number}
            // height={this.options.height}
            timeMode={'min'}
            value={value ? value.min ? value.min : null : null}
            format={format}
            theme={this.props.theme}
            style={style}
            endDate={minMaxValue}
            onStopEdit={e1 => {
              if(e1) {
                e1 = that.getRValue(this.min.realValue, 'min');
                e1 = dayjsUtils.timeToLocal(e1).date.getTime();
              }
              this.setState({
                maxMinValue: e1,
                value: {
                  min: e1,
                  max: this.state.value.max
                }
              }, () => {
                BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
              })

            }}
          >
          </BsyDateTime>
        </div>
        <div className=" limit-to">~</div>
        <div className='limit-item'>
          <BsyDateTime
            getContext={this.getContextMax}
            width={width4number}
            // height={this.options.height}
            timeMode={'max'}
            value={value ? value.max ? value.max : null : null}
            format={format}
            theme={this.props.theme}
            style={style}
            startDate={maxMinValue}
            onStopEdit={e1 => {
        
              if(e1) {
                e1 = that.getRValue(this.max.realValue, 'max')
                e1 = dayjsUtils.timeToLocal(e1).date.getTime();
              }

              this.setState({
                minMaxValue: e1,
                value: {
                  max: e1,
                  min: this.state.value.min
                }
              }, () => {
                BsyUtils.applyFunc(that, that.options.onStopEdit, [], !1)
              })

            }}
          >

          </BsyDateTime>
        </div>
      </div>
    )
  }
}
